import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useParams } from 'react-router-dom';
import { getPatientProducts } from '../service';
import {
  ColumnData,
  OrderTypeProps,
  PatientProductResponse,
  PatientProductsProps,
} from '../interface/interface';
import { Table } from '../components/Table';

export default function PatientProducts() {
  const { patientId } = useParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [products, setProducts] = useState<PatientProductsProps[]>([]);

  useEffect(() => {
    if (!user?.access_token || !patientId) {
      console.warn('User access Token or Patient id not found');
      return;
    }

    setLoading(true);

    getPatientProducts(user.access_token, patientId)
      .then((data: PatientProductResponse) => {
        setProducts(data.data);
      })
      .catch((err) => {
        console.error(err);
        setProducts([]);
      });

    setLoading(false);
  }, [user?.access_token]);

  const columns: Array<ColumnData> = [
    {
      key: 'name',
      header: () => 'Product Name',
      isSortable: true,
      cell: (info) => info.getValue() ?? '-',
    },
    {
      key: 'count',
      header: () => 'Order Count',
      isSortable: true,
      cell: (info) => info.getValue() ?? '-',
    },
  ];
  return (
    <Table
      columns={columns}
      data={products}
      enablePagination={false}
      enableSorting={true}
      enableSearch={true}
      childLoader={loading}
      order={OrderTypeProps.PRODUCT}
    />
  );
}
